export var OrderPaymentFormEmbeddedPaymentConnectorActionType;
(function (OrderPaymentFormEmbeddedPaymentConnectorActionType) {
    OrderPaymentFormEmbeddedPaymentConnectorActionType["LoadingPaymentClient"] = "LoadingPaymentClient";
    OrderPaymentFormEmbeddedPaymentConnectorActionType["LoadedPaymentClient"] = "LoadedPaymentClient";
    OrderPaymentFormEmbeddedPaymentConnectorActionType["PaymentStarting"] = "PaymentStarting";
    OrderPaymentFormEmbeddedPaymentConnectorActionType["PaymentButtonStateChanged"] = "PaymentButtonStateChanged";
})(OrderPaymentFormEmbeddedPaymentConnectorActionType || (OrderPaymentFormEmbeddedPaymentConnectorActionType = {}));
